<template>
    <a-spin :spinning="loading">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" :autoFormCreate="(form) => {
                    this.form = form;
                }
                    ">
                    <a-row :gutter="48">
                        <a-col :md="12" :sm="24">
                            <a-form-item label="用户uid">
                                <a-input placeholder="请扫用户码" disabled v-model="formData.uid" />
                            </a-form-item>
                            <template v-if="userInfo">
                                <div style="color:red;font-size:24px">执行操作前，请务必核对用户ID是否匹配！</div>
                                <a-form-item label="用户ID">
                                    <span style="font-size:36px;font-weight: bold;">{{ userInfo.uid }}</span>
                                </a-form-item>
                                <a-form-item label="用户头像" style="height:128px">
                                    <img class="avatar" :src="userInfo.avatar" alt="avatar" width=128 height=128
                                        style="border-radius:64px;" />
                                </a-form-item>
                                <a-form-item label="用户昵称">
                                    {{ userInfo.nickname }}
                                </a-form-item>
                                <a-form-item label="游戏币数量">
                                    {{ userInfo.game_coins }}
                                </a-form-item>
                                <a-form-item label="取币数量">
                                    <a-input-number v-model.number="formData.quantity" :min="0" :max="100000" :step="1"
                                        :precision="0" />
                                </a-form-item>
                            </template>
                        </a-col>
                    </a-row>
                    <a-button v-if="userInfo" type="primary" @click="submit">提交</a-button>
                    <a-button v-if="userInfo" style="margin-left:12px"
                        @click="userInfo = null; formData = { uid: '', quantity: 0 }">重新扫码</a-button>
                </a-form>
            </div>
        </a-card>
    </a-spin>
</template>
<script>

import { queryUserInfo, withdrawalGameCoin } from '@/api/user'
import { Modal } from 'ant-design-vue'
import HandleUserAbnormal from './HandleUserAbnormal'

export default {
    name: 'Doll',
    data() {
        return {
            userInfo: null,
            formData: {
                uid: "",
                quantity: 0,
            },
            key: "",
            keyTimeID: 0,
            loading: false,
        }
    },
    mixins: [HandleUserAbnormal],
    watch: {
        userInfo: {
            handler(val) {
                if (!this.userInfo) {
                    this.bindWindowScan()
                } else {
                    this.removeWindowScan()
                }
            },
            immediate: true
        }
    },
    methods: {
        submit() {
            if (!this.formData.quantity) {
                this.$message.error('取币数量不能为0');
                return;
            }
            Modal.confirm({
                title: '确认取币',
                content: `确认给用户 ${this.userInfo.nickname} 取 ${this.formData.quantity} 游戏币吗？`,
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    const quantity = this.formData.quantity;
                    this.loading = true
                    withdrawalGameCoin(this.userInfo.uid, quantity).then(res => {
                        this.$message.success('操作成功')
                        this.userInfo.game_coins -= quantity
                        this.formData.quantity = 0
                    })
                        .finally(() => {
                            this.loading = false
                        })
                },
            });
        },
        handleScan(e) {
            if (this.keyTimeID) {
                clearTimeout(this.keyTimeID)
            }
            this.keyTimeID = setTimeout(() => {
                this.key = ""
            }, 50)
            this.key += e.key
            if (this.key.indexOf("Enter") > -1) {
                this.key = this.key.replace("Enter", "")
                console.log(this.key)
                if (/[^\d]/.test(this.key) || this.key.length < 8 || this.key == "") {
                    return
                }
                this.getUserInfo()
            }
        },
        bindWindowScan() {
            window.addEventListener('keydown', this.handleScan);
        },
        removeWindowScan() {
            window.removeEventListener('keydown', this.handleScan);
        },
        getUserInfo() {
            this.loading = true
            queryUserInfo({ uid: this.key }).then(res => {
                const { uid, nickname, avatar, id, doll, game_coins, is_abnormal } = res;
                if (is_abnormal) {
                    this.loading = false
                    this.showAbnormalModal()
                    return
                }
                this.userInfo = {
                    id,
                    uid,
                    nickname,
                    avatar,
                    doll,
                    game_coins,
                }
                this.formData.uid = uid
                this.formData.quantity = 0
            })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {

    },
    beforeDestroy() {
        this.removeWindowScan()
    }
}
</script>